import React, { useState, useEffect, useMemo } from "react";
import { useSubscription } from "@apollo/client";
import moment from "moment";
import {Box} from "grommet";
import {
    MaterialReactTable,
    useMaterialReactTable,
} from 'material-react-table';
import { QUERY_LIST } from './EntranceGQL';

function EntranceList() {
    const { data: subscriptionData, loading, error } = useSubscription(QUERY_LIST);
    const [data, setData] = useState([]);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 50,
    });
    const [rowCount, setRowCount] = useState(0);

    // Define columns
    const columns = useMemo(() => [
        {
            accessorKey: 'datetime',
            header: 'Data e Ora',
            Cell: ({ cell }) => moment(cell.getValue()).format("DD-MM-YYYY HH:mm:ss"),
        },
        {
            accessorKey: 'is_guest',
            header: 'È un accesso ospite/gara?',
            Cell: ({ cell }) => cell.getValue() ? 'Sì' : 'No',
        },
        {
            accessorKey: 'anonymous_check',
            header: 'Accesso Anonimo',
            Cell: ({ cell }) => cell.getValue() ? 'Sì' : 'No',
        },
        {
            accessorKey: 'userName',
            header: 'Utente',
            Cell: ({ cell, row }) => {
                const user = row.original.usersregister_userregister;
                if (!user) return '-';
                return `${user.name} ${user.surname}`;
            },
        },
        {
            accessorKey: 'fiscal_code',
            header: 'Codice Fiscale',
            Cell: ({ cell, row }) => {
                return row.original.usersregister_userregister?.fiscal_code || '-';
            },
        },
    ], []);

    useEffect(() => {
        if (subscriptionData?.clubmate_entrance_entrance) {
            const entrances = subscriptionData.clubmate_entrance_entrance;
            setData(entrances);
            setRowCount(entrances.length);
        }
    }, [subscriptionData]);

    const table = useMaterialReactTable({
        columns,
        data,
        state: {
            isLoading: loading,
            pagination,
        },
        onPaginationChange: setPagination,
        enableGlobalFilter: false,
        enableColumnFilters: false,
        enableStickyHeader: true,
        enableStickyFooter: true,
        muiTableContainerProps: {
            sx: { maxHeight: 'calc(80vh - 100px)' }
        },
        muiPaginationProps: {
            rowsPerPageOptions: [25, 50, 100],
        },
        initialState: {
            density: 'compact',
        },
    });

    return (
        <Box overflow="auto" height="100%" width="100%" alignSelf='center' style={{marginTop:'8px'}} margin={"small"}>
            <div style={{ height: '80vh', width: '98%' , marginLeft: "8px" }}>
                <MaterialReactTable table={table}/>
            </div>
        </Box>
    );
}

export default EntranceList;